'use client';

import { useLocalePricingInvalidation } from '@/lib/hooks/use-locale-pricing-invalidation';

/** Mount inside IntlProvider to refresh price caches on locale change. */
export function LocalePricingInvalidator() {
  useLocalePricingInvalidation();
  return null;
}
